import React from 'react';
import Header from './Header.component';
import CssBaseline from '@material-ui/core/CssBaseline';
import LanguageSelector from '../LanguageSelector/LanguageSelector.component';
import ThemeSelector from '../ThemeSelector/ThemeSelector.component';
import { useParams, useLocation } from 'react-router-dom';
import { getBoxes } from 'Store/modules/dashboard/selectors';
import { connect } from 'react-redux';
import Copyright from '../Copyright';

const MainLayout = ({ children, boxes }) => {

    const { dashboardId } = useParams();
    const location = useLocation();
    const mainClass = (boxes && boxes.length) ? 'mainLayout' : 'mainLayout introImg';
    
   
    const isMapPath = location.pathname === '/map';
    const isFleetViewPath = location.pathname === '/fleet-view';
    const isSettingsPath = location.pathname.startsWith('/settings');
    const layoutClassName = [
        mainClass,
        isSettingsPath ? 'settingsPageMainLayout' : '',
        isFleetViewPath ? 'fleetViewMainLayout' : '',
    ].filter(Boolean).join(' ');

    const footerStyles = isMapPath ? {
        position: 'absolute',
        bottom: '70px',
        width: '100%'
    } : {};

    return (
        <div className={layoutClassName}>
            <CssBaseline />
            {!dashboardId && <Header />}
            <main className="main">
                {children}
            </main>
            {
                !dashboardId ? (
                    <footer className="mainFooter" style={footerStyles}>
                        <div className="mainContainer">
                            <div className="footerWrapper">
                                <ThemeSelector />
                                <LanguageSelector />
                                <Copyright />
                            </div>
                        </div>
                    </footer>
                ) : <footer className="mainFooter empty" />
            }
        </div>
    );
};

const mapStateToProps = state => ({
    boxes: getBoxes(state),
});

export default connect(mapStateToProps)(MainLayout);
